import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { Spacer } from 'foundations-components/components/Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UnrecoverableError = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(UIErrorMessage, {
    type: "badRequest",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "UP_FRONT_REQUEST_ERROR"
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.errors.failedToLoadWholeApp"
      })
    })]
  })]
});
export default UnrecoverableError;